import { Instruction, OpCode } from '../internal.js';
/**
 * Import Instruction.
 *
 * Imports code by the given pakcage ID.
 */
export class ImportInstruction extends Instruction {
    pkgId;
    constructor(pkgId) {
        super(OpCode.IMPORT);
        this.pkgId = pkgId;
    }
}
/**
 * Import Args Serializer object - implements the Serializable interface.
 */
export const ImportArgsSerializer = {
    read(buf) {
        const pkgId = buf.readFixedBytes(32);
        return new ImportInstruction(pkgId);
    },
    write(buf, inst) {
        buf.writeFixedBytes(inst.pkgId);
        return buf;
    }
};
